<h1><a href="/admin-home">Admin</a> - Log in as User</h1>

<section>
  <p><label>Dealer:
    <input type="text" id="admin-dealer" [(ngModel)]="search" (keyup)="displayDealers()" autofocus="autofocus">
  </label></p>
</section>

<section>
  <p>{{loading}}</p>
  <table class="data">
    <thead><tr><td>PA Code</td><td>Name</td><td>Techs</td></tr></thead>
    <tbody>
      @for (dealer of displayedDealers; track dealer) {
        <tr>
          <td>{{dealer.pa_code}}</td>
          <td>{{dealer.name}}</td>
          <td class="number">{{dealer.tech_count}}</td>
          <td><button (click)="fly(dealer)">Be {{dealer.pa_code}}</button></td>
        </tr>
      }
    </tbody>
  </table>
</section>
